import React from 'react';
import Faq from './Faq';

/**
 * Homepage FAQ teaser: 3–5 questions with "View all FAQs" link.
 */
const FaqHome: React.FC = () => {
  return (
    <section id="faq" className="faq-home">
      <div className="container">
        <h2 className="faq-home-title">Frequently Asked Questions</h2>
        <Faq
          limit={5}
          showSections={false}
          showViewAllLink={true}
        />
      </div>
    </section>
  );
};

export default FaqHome;
